export enum DocplannerIntegrationMethod {
  none,
  sso,
  url,
}
